export const ADMIN_CONFIG = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    timeout: 15000,
  },
  appName: import.meta.env.VITE_APP_NAME || "Innov' Paie Admin",
  auth: {
    tokenKey: 'admin_tokens',
    userKey: 'admin_user',
  },
  pagination: {
    defaultPageSize: 25,
    maxPageSize: 100,
  },
} as const;
